module.exports = __webpack_public_path__ + "static/media/br.pictogram.b1438171.svg";